const translations = {
  'zh-Hant-TW': { scroll_hint: '請左右滑動查看內容' },
  'zh-CN': { scroll_hint: '请左右滑动查看內容' },
  'en':    { scroll_hint: 'Please move back and forth' },
  'ja':    { scroll_hint: '左右にスクロールしてください' }
};

const currentLang = document.documentElement.lang || 'en';
const hintText = translations[currentLang]?.scroll_hint || translations.en.scroll_hint;

function wrapScrollableTables() {
  $('.table-responsive').each(function () {
    const $table = $(this);

    if ($table.closest('.table-scroll').length) return;

    const isScrollable = this.scrollWidth > this.clientWidth;

    const scrollHintHtml = `
      <div class="scroll-hint">
        <div class="hint-inner">
          <span class="hint">${hintText}</span>
          <span class="close"></span>
        </div>
      </div>
    `;

    const $wrapper = $('<div class="table-scroll"></div>');
    if (isScrollable) {
      $wrapper.addClass('is-scrollable');
    }

    $table.wrap($wrapper);
    $table.before(scrollHintHtml);
  });
}

function checkTableScrollability() {
  $('.table-scroll').each(function () {
    const $wrapper = $(this);
    const $responsive = $wrapper.find('.table-responsive');

    if ($responsive.length === 0) return;

    if ($responsive[0].scrollWidth > $responsive[0].clientWidth) {
      $wrapper.addClass('is-scrollable');
    } else {
      $wrapper.removeClass('is-scrollable');
    }
  });
}

// 關閉提示
$(document).on('click', '.scroll-hint .close', function () {
  $(this).closest('.table-scroll').removeClass('is-scrollable');
});

// 左右拖曳
function enableTableDragScroll() {
  let isDown = false;
  let startX;
  let scrollLeft;

  $(document).on('mousedown', '.table-responsive', function (e) {
    isDown = true;
    startX = e.pageX - this.offsetLeft;
    scrollLeft = this.scrollLeft;
  });

  $(document).on('mouseleave mouseup', '.table-responsive', function () {
    isDown = false;
  });

  $(document).on('mousemove', '.table-responsive', function (e) {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - this.offsetLeft;
    const walk = (x - startX) * 1;
    this.scrollLeft = scrollLeft - walk;
  });
}

$(window).on('load resize', function () {
  wrapScrollableTables();
  checkTableScrollability();
  enableTableDragScroll();
});

$(document).on('click', '.table-scroll .table-responsive', function () {
  const $wrapper = $(this).closest('.table-scroll');
  $wrapper.removeClass('is-scrollable');
  $wrapper.find('.scroll-hint').remove();
});
